import { useSelector } from 'react-redux'
import { selectHopTimusEnabled } from '@/containers/Login/AuthSelectors'

const useHopTimusAskLineEnabled = () => useSelector(selectHopTimusEnabled)

export default useHopTimusAskLineEnabled
